import React from "react";
import {Marker} from "react-google-maps";
import {connect} from "react-redux";

class StoreMarker extends React.Component {
  render() {
    return <Marker position={this.props.location} icon={this.props.marker} />;
  }
}

const mapStateToProps = (state) => {
  return {
    marker: state.images.marker
  };
};

export default connect(mapStateToProps)(StoreMarker);


// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/StoreMarker.js